import React, { Dispatch, FC } from 'react';
import { Row } from 'react-table';
import * as classnames from 'classnames';

import { ICell } from 'types/table';

import styles from './styles.module.css';

interface ITableRowProps {
  index: number;
  clickedRowId?: string | null;
  row: Row<Record<string, unknown>>;
  selectedRowIds?: string[];
  onRowClick?: Dispatch<any>;
}

export const TableRow: FC<ITableRowProps> = ({ index, clickedRowId, row, selectedRowIds, onRowClick }) => {
  const rowClassname = classnames(styles.tr, styles.tableRow, 'sticky-table-row', {
    [styles.isClickable]: !!onRowClick,
  });

  const cellClassname = classnames(styles.td, styles.tableCell, {
    [styles.oddRow]: index % 2 !== 0,
    [styles.cellSelected]: selectedRowIds?.includes(row.id),
    [styles.cellClicked]: !!clickedRowId && !!row.original.id && clickedRowId === String(row.original.id),
  });

  const getCellProps = ({ getCellProps, column }: ICell) => ({
    ...getCellProps([{ className: column?.className, style: { ...(column.isFlexUnset && { flex: 'unset' }) } }]),
  });

  const handleRowClick = () => {
    !!onRowClick && onRowClick(row.original);
  };

  return (
    <div {...row.getRowProps()} className={rowClassname} onClick={handleRowClick}>
      {row.cells.map((cell: ICell) => (
        <div {...getCellProps(cell)} className={cellClassname}>
          {cell.column.withoutCellWrapper ? (
            cell.render('Cell')
          ) : (
            <div className={styles.tableCellContent}>{cell.render('Cell')}</div>
          )}
        </div>
      ))}
    </div>
  );
};
